enum NotificationType {
    EMAIL = 'email',
    MOBILE = 'mobile'
  }
  export default NotificationType;
  